export const getSbpPayUrl = (payUrl) => {
    // TODO: определять PAY_KEEPER по paymentMethodCd из API вместо анализа URL.
    if (!payUrl.toLowerCase().includes('paykeeper')) {
        return payUrl;
    }

    return payUrl + '?pstype=sbp_tochka';
};
